import React from 'react'
import styled from '@emotion/styled'

const Share = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: right;
  .wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }
  a {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 1.5rem;
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
  svg {
    fill: black;
  }
  span {
    color: white;
    letter-spacing: -0.01em;
    margin-bottom: 0.4rem;
    margin-right: 0.6rem;
    display: block;
    word-spacing: 0.2em;
    text-shadow: rgb(0 0 0 / 90%) 0px 0px 2px, rgb(0 0 0 / 60%) 0px 0px 20px;
  }
`
const ShareComponent = ({
  url,
  title,
  hashtags,
  via = 'latercera',
  comparte = 'comparte',
}) => {
  return (
    <Share>
      <span dangerouslySetInnerHTML={{ __html: comparte }}></span>
      <div className="wrap">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target="_blank"
          rel="noopener noreferrer">
          <svg className="icon-facebook" viewBox="0 0 24 24">
            <use xlinkHref="#facebook-icon-rounded"></use>
          </svg>
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
            title,
          )}&url=${url}&hashtags=${hashtags}&via=${via}`}
          target="_blank"
          rel="noopener noreferrer">
          <svg className="icon-twitter" viewBox="0 0 24 24">
            <use xlinkHref="#twitter-icon-rounded"></use>
          </svg>
        </a>
        <a
          href={`https://www.reddit.com/submit?url=${url}&title=${title}`}
          target="_blank"
          rel="noopener noreferrer">
          <svg className="icon-reddit" viewBox="0 0 24 24">
            <use xlinkHref="#reddit-icon-rounded"></use>
          </svg>
        </a>
        <a
          href={`https://api.whatsapp.com/send?phone=&text=${url} ${title}`}
          target="_blank"
          rel="noopener noreferrer">
          <svg className="icon-whatsapp" viewBox="0 0 24 24">
            <use xlinkHref="#whatsapp-icon-rounded"></use>
          </svg>
        </a>
      </div>
    </Share>
  )
}

export default ShareComponent
